module.exports = __webpack_public_path__ + "static/media/wagz_mobile.2034ba16.svg";